class FormSubmits {

    constructor() {
        this.variables();
        this.cacheDOM();
        this.bindEvents();
        this.onLoad();
    }

    variables() {
        this.projectForm = '#testForm'; // Main form id or ids
        this.formApi = window.location.origin + '/prijaveApi/'; // Main api url
        this.projectsApi = this.formApi + 'projects'; // Url for save (post) and load (get)
        this.emptyProjectsApi = this.formApi + 'empty-projects'; // Url for create empty projects
        this.copyProjectApi = this.formApi + 'copy-project'; // Url for copy project
        this.agenciesApi = this.formApi + 'agencies-data'; // Url for save (post) and load (get)
        this.removeProjectApi = this.formApi + 'remove-project/'; // Url for save (post) and load (get)
        this.projectsUrl = "/prijava/projekti";
        this.packagesUrl = "/prijava/paketi";


        this.projectSlick = $('.project-slider'); // Project slickslider
        this.agenciesOrganizationsSelect = this.projectForm + ' #agency, ' + this.projectForm + ' #organization'; // Selectbox for agency and org
        this.defaultWarningModal = '#default_project'; // Default modal
        this.countProjects = '[data-count-projects]'; // Count slicks or projects

        // Buttons
        this.addNewProjectButton = ".add-new-project"; // Add new project button
        this.removeActiveProjectButton = ".remove-project"; // Remove project button
        this.copyProjectButton = ".copy-project"; // Remove project button
        this.choosePackageButton = "button[data-package-count]"; // Select package button

        this.changedInputConfirmLeave = 'changed-input'; // Class of changes for confirm before leave site
        this.btnSuccessNewProject = '#success-new-project';
    }

    cacheDOM() {
    }

    bindEvents() {
        // $(document).on('submit', this.projectForm, this.processSaveForm.bind(this)); // Save form
        $(document).on('click', this.addNewProjectButton, this.createData.bind(this)); // Create new form
        $(document).on('click', this.removeActiveProjectButton, this.processRemoveProject.bind(this)); // Remove project
        $(document).on('click', this.copyProjectButton, this.processCopyProject.bind(this)); // Copy project
        $(document).on('click', this.choosePackageButton, this.chooseProject.bind(this)); // Select package for project
        // $(document).on('change', this.agenciesOrganizationsSelect, this.getAgenciesOrganizationsData.bind(this)); // Get data for agencies and organization
        $(document).on('change keyup keydown', 'input, textarea, select', this.addClassForUnsaved.bind(this)); // Prevent refresh if unsaved data
        $(window).on('beforeunload', this.beforeUnloadFunction.bind(this)); // Prevent refresh if unsaved data

        $(document).on('click', this.btnSuccessNewProject, this.successNewProject.bind(this)); // success new project
    }

    onLoad() {
        this.init();
        FormSubmits.ajaxLoad();
        this.urlValidation(); // Url validation
        this.formValidator(); // Form validator
    }

    urlValidation() {
        $.validator.addMethod('validUrl', function (value, element) {
            if (value.substr(0, 7) != 'http://' && value.substr(0, 8) != 'https://' && value.substr(0, 6) != 'ftp://') {
                value = 'http://' + value;
            }
            if (value.substr(value.length - 1, 1) != '/') {
                value = value + '/';
            }
            return this.optional(element) || /^(http|https|ftp):\/\/[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,8}(:[0-9]{1,5})?(\/.*)?$/i.test(value);
        }, 'Please enter a valid URL');
    }

    /**
     * Form validation
     */
    formValidator() {
        let that = this;
        let projectForm = $(this.projectForm);
        projectForm.validate({
            rules: {
                'basic_info[project_name]': 'required',
                'basic_info[project_url]': {
                    required: true,
                    validUrl: true
                },
                'contact_data[contact_name]': 'required',
                'contact_data[contact_email]': {
                    required: true,
                    email: true
                },
            },
            messages: {
                'basic_info[project_name]': 'Polje ne sme biti prazno',
                'basic_info[project_url]': {
                    required: "Polje ne sme biti prazno",
                    validUrl: "Prosimo vnesite veljaven url naslov"
                },
                'contact_data[contact_name]': 'Polje ne sme biti prazno',
                'contact_data[contact_email]': {
                    required: "Polje ne sme biti prazno",
                    email: "Prosimo vnesite veljaven email naslov"
                }
            },
            submitHandler: function (form) {
                // projectForm.submit();
                that.ajaxSaveForm();
            },
            invalidHandler: function (event, validator) {
                const errors = validator.numberOfInvalids();
                $('input.error').removeClass('error').parents('.form-group').removeClass('has-error');
                if (errors) {
                    for (let item of validator.errorList) {
                        $(item.element).addClass('error').parents('.form-group').addClass('has-error');
                    }
                }
            },
            highlight: function (element, errorClass) {
                if ($(element).next().is('label:visible')) $(element).parents('.form-group').addClass('has-error');
            },
            unhighlight: function (element) {
                if (!$(element).next().is('label:visible')) $(element).parents('.form-group').removeClass('has-error');
                else $(element).parents('.form-group').addClass('has-error');
            },
        });
    }


    /**
     * Ajax Loader
     */

    static ajaxLoad() {
        $(document).ajaxStart(function () {
            $("#ajaxLoader").show();
        });
        $(document).ajaxStop(function () {
            $("#ajaxLoader").hide();
        });
    }

    /**
     * set Before unload (prevent refresh when not saved)
     */
    addClassForUnsaved(e) {
        let target = $(e.target);
        target.addClass(this.changedInputConfirmLeave);

        if (target.is($('input[name="basic_info[project_name]"]'))) {
            this.projectSlick.find('.slide-is-active a').text(target.val());
        }
    }

    beforeUnloadFunction() {
        if ($('.' + this.changedInputConfirmLeave).length) {
            return 'You haven\'t saved your changes.';
        }
    }

    /**
     * Init form part (slick)
     */
    init() {
        let getActiveId = this.projectSlick.find('.slide-is-active').data('get-key');

        this.projectSlick.slick({
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            centerMode: false,
            variableWidth: false,
            slidesToScroll: 1,
            initialSlide: (getActiveId > 3 ? getActiveId : 0),
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        initialSlide: (getActiveId > 2 ? getActiveId : 0)
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2,
                        initialSlide: (getActiveId > 1 ? getActiveId : 0)
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        initialSlide: getActiveId
                    }
                },
                {
                    breakpoint: 475,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });

        if ((this.projectSlick.find(".slick-slide").length < 5 && window.innerWidth > 1280) ||
            (this.projectSlick.find(".slick-slide").length < 4 && window.innerWidth < 1280 && window.innerWidth > 1000) ||
            (this.projectSlick.find(".slick-slide").length < 3 && window.innerWidth < 1000 && window.innerWidth > 768)) {
            this.projectSlick.addClass("not-slider");
        }

        this.projectSlick.slick('refresh');

        // category faker change event
        specto_faker.init({
            animated: true,
            object_selector: "select#category",
            on_change: function (newVal, jsEvent) {
                $('.form-group__explanation').addClass('is-active');
            },
            on_init: function(fakers) {
                // remove first item (placeholder)
                fakers[0].find('.drop-selection').find('div').get(0).remove();
            }
        });
    }

    /**
     * Save form
     */

    ajaxSaveForm() {
        let that = this;

        let fd = new FormData();

        let modalType = '';
        $.each($(this.projectForm).find('input,textarea,select'), function () {
            let name = $(this).attr('name');
            let val = $(this).val();
            if (name === 'basic_info[project_img]') {
                let img = $(this)[0].files[0];
                fd.append(name, (img !== undefined ? img : ''));
            } else if (name === 'is_ready') {
                fd.append(name, $(this).is(':checked'));
                if ($(this).is(':checked')) {
                    modalType = 'complete';
                }
            } else if (name === 'accept_1') {
                fd.append(name, $(this).is(':checked'));
            } else if (name === 'project_data[is_dimaq]') {
                fd.append(name, $(this).is(':checked'));
            } else {
                fd.append(name, val);
            }
        });

        //Save project
        $.ajax({
            url: this.projectsApi, // Url to which the request is send
            type: "POST",             // Type of request to be send, called as method
            data: fd, // Data sent to server, a set of key/value pairs (i.e. form fields and values)
            contentType: false,       // The content type used when sending data to the server.
            cache: false,             // To unable request pages to be cached
            processData: false,        // To send DOMDocument or non processed data file it is set to false
            success: function (data)   // A function to be called if request succeeds
            {
                $(that.projectForm + " input[name='basic_info[id]']").each(function(){
                    if(this.value === "") this.value = data.data.id;
                });
                $.each(data.agencies, function (k, v) {
                    $(that.projectForm + " input[name='agency_data[" + k + "][id]']").each(function(){
                        if(this.value === "") this.value = v.id;
                    });
                });
                $.each(data.organizations, function (k, v) {
                    $(that.projectForm + " input[name='organization_data[" + k + "][id]']").each(function(){
                        if(this.value === "") this.value = v.id;
                    });
                });
                $.each(data.customers, function (k, v) {
                    $(that.projectForm + " input[name='customer_data[" + k + "][id]']").each(function(){
                        if(this.value === "") this.value = v.id;
                    });
                });

                $(that.projectForm).find('.' + that.changedInputConfirmLeave).removeClass(that.changedInputConfirmLeave); // Unbind prevent reload dialog

                // set status
                const status = data.project_status.toLowerCase();
                const statusElm = '#proj-status-' + data.data.id;
                $(statusElm).text(status);
                if (status === 'oddano') {
                    $(statusElm).addClass('finished');
                } else {
                    $(statusElm).removeClass('finished');
                }

                // Modal
                let html = '<h3>Uspešno!</h3>';
                html += '<p>Vse spremembe so se uspešno shranile.</p>';
                that.confirmModals(html, '', 'V redu', modalType);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // Modal
                let html = '<h3>NAPAKA!</h3>';
                html += '<p>Prišlo je do napake, prosimo, preverite vse obvezne podatke ali poskusite pozneje.</p>';
                that.confirmModals(html, '', 'V redu', '');
            }
        });
    }

    /**
     * Choose Package
     */

    chooseProject(e) {
        e.preventDefault();
        let target = $(e.target);
        let count = target.data("package-count");
        let that = this;

        this.createEmptyProject(count).then(function () {
            window.location.replace(window.location.origin + that.projectsUrl);

        });
    }

    /**
     * Add Project
     */

    createData(e) {
        e.preventDefault();
        let count = $(this.countProjects).length;
        let that = this;
        let html = '<h3>Obvestilo!</h3>';

        switch (true) {
            case (count === 2):
                html += '<p>Prešli boste v paketno ponudbo (trije projekti).</p>';
                that.confirmModals(html, 'Ustvari', 'Prekliči', 'create');
                break;
            case (count === 3 || count >= 5):
                html += '<p>Ker ste izven paketne ponudbe, nas lahko za ceno prijave kontaktirate na <a href="mailto:info@websi.si">info@websi.si</a>.</p>';
                that.confirmModals(html, 'Ustvari', 'Prekliči', 'create');
                break;
            case (count === 4):
                html += '<p>Prešli boste v paketno ponudbo (pet projektov).</p>';
                that.confirmModals(html, 'Ustvari', 'Prekliči', 'create');
                break;
            default:
                that.createEmptyProject().then(function (data) {
                    window.location.href = window.location.href.replace(/\?.+$/, "") + "?id=" + data.id;
                });
                break;
        }
    }

    /**
     * Create empty Project
     */

    createEmptyProject(count = 1) {
        let that = this;
        return new Promise(
            function (resolve, reject) {
                $.ajax({
                    type: 'POST',
                    url: that.emptyProjectsApi,
                    data: {count: count},
                    success: function (data) {
                        resolve(data.data);
                    },
                    error: function (error) {
                        reject(error);
                    }
                });
            });
    }

    copyProject(projId) {
        let that = this;
        return new Promise(
            function (resolve, reject) {
                $.ajax({
                    type: 'POST',
                    url: that.copyProjectApi,
                    data: {project_id: projId},
                    success: function (data) {
                        resolve(data.data);
                    },
                    error: function (error) {
                        reject(error);
                    }
                });
            });
    }


    /**
     * Confirm before remove project
     */
    processRemoveProject(e) {
        e.preventDefault();
        let that = this;
        let count = $(this.countProjects).length;
        let html = '<h3>Obvestilo!</h3>';
        const projId = $(e.target).data('id');
        const projectTitle = $(e.target).closest('.project-block').find('.project-block__title').text();
        html += '<p>Ste prepričani, da želite izbrisati projekt <b>' + projectTitle + '</b>?</p>';

        switch (true) {
            case (count === 4):
                html += '<p>Prešli boste v paketno ponudbo (trije projekti).</p>';
                that.confirmModals(html, 'Izbriši', 'Ne izbriši', 'remove', projId);
                break;
            case (count === 5 || count >= 6):
                html += '<p>Ker ste izven paketne ponudbe, nas lahko za ceno prijave kontaktirate na <a href="mailto:info@websi.si">info@websi.si</a>.</p>';
                that.confirmModals(html, 'Izbriši', 'Ne izbriši', 'remove', projId);
                break;
            case (count === 6):
                html += '<p>Prešli boste v paketno ponudbo (pet projektov).</p>';
                that.confirmModals(html, 'Izbriši', 'Ne izbriši', 'remove', projId);
                break;
            default:
                that.confirmModals(html, 'Izbriši', 'Ne izbriši', 'remove', projId);
                break;
        }
    }


    /**
     * Remove Project
     */

    removeProject(projId) {
        let count = $(this.countProjects).length;
        let that = this;

        $.ajax({
            url: this.removeProjectApi + projId, //this.projectSlick.find('.slide-is-active').attr('id'), // Url to which the request is send
            type: "POST",             // Type of request to be send, called as method
            data: {}, // Data sent to server, a set of key/value pairs (i.e. form fields and values)
            success: function ()   // A function to be called if request succeeds
            {
                if (count <= 1) {
                    window.location.replace(window.location.origin + that.packagesUrl);
                } else {
                    window.location.replace(window.location.href.replace(/\?.+$/, ""));
                }
            }
        });
    }

    processCopyProject(e) {
        e.preventDefault();
        let that = this;
        let count = $(this.countProjects).length;
        let html = '<h3>Obvestilo!</h3>';
        const projId = $(e.target).data('id');
        const projectTitle = $(e.target).closest('.project-block').find('.project-block__title').text();
        html += '<p>Ste prepričani, da želite kopirati projekt <b>' + projectTitle + '</b>?</p>';

        switch (true) {
            case (count === 2):
                html += '<p>Prešli boste v paketno ponudbo (trije projekti).</p>';
                that.confirmModals(html, 'Kopiraj', 'Ne kopiraj', 'copy', projId);
                break;
            case (count === 3 || count >= 5):
                html += '<p>Ker ste izven paketne ponudbe, nas lahko za ceno prijave kontaktirate na <a href="mailto:info@websi.si">info@websi.si</a>.</p>';
                that.confirmModals(html, 'Kopiraj', 'Ne kopiraj', 'copy', projId);
                break;
            case (count === 4):
                html += '<p>Prešli boste v paketno ponudbo (pet projektov).</p>';
                that.confirmModals(html, 'Kopiraj', 'Ne kopiraj', 'copy', projId);
                break;
            default:
                that.confirmModals(html, 'Kopiraj', 'Ne kopiraj', 'copy', projId);
                break;
        }
    }

    /**
     * Get and set agency/organization data
     * @param e
     */
    getAgenciesOrganizationsData(e) {
        let target = $(e.target);

        if (target.val() == "delete-agency-data") {
            target.parent().parent().find(".drop-value").empty().text("< Izberite agencijo >");
            target.parent().find("div.rel-disabled").empty().text("< Izberite agencijo >");

            $(".agency input").each(function () {
                $(this).attr("disabled", false);
                $(this).val("");
            });
        } else if (target.val() == "delete-organization-data") {
            target.parent().parent().find(".drop-value").empty().text("< Izberite organizacijo / podjetje >");
            target.parent().find("div.rel-disabled").empty().text("< Izberite organizacijo / podjetje >");

            $(".organization input").each(function () {
                $(this).attr("disabled", false);
                $(this).attr("value", "");
            });
        } else {
            $.get(this.agenciesApi + '/' + target.val(), function (data) {
                let type = data.data.type;
                let parent = target.parents('.' + type);
                $.each(data.data, function (k, v) {
                    if (k === 'id') parent.find('input[name="' + type + '_data[' + k + ']"]').val(v);
                    else parent.find('input[name="' + type + '_data[' + k + ']"]').val(v).attr('disabled', 'disabled');
                });
            });
        }

    }

    /**
     * Create confirm modal and call type
     * @param html (body of modal)
     * @param saveButton (Confirm button text)
     * @param dismissButton (Dismiss button text)
     * @param type (type of function)
     */
    confirmModals(html = '', saveButton = 'Shrani', dismissButton = 'Zapri', type = null, projId = 0) {
        let that = this;
        // Set html
        let confirmButton = $(this.defaultWarningModal + ' .button-confirm');
        let cancelButton = $(this.defaultWarningModal + ' .button-cancel');
        $(this.defaultWarningModal + ' .modal-content-wrap').html(html);
        if (saveButton !== '') {
            confirmButton.text(saveButton).show();
        } else {
            confirmButton.hide();
        }
        if (dismissButton !== '') {
            cancelButton.text(dismissButton).show();
        } else {
            cancelButton.hide();
        }

        // Show
        $(this.defaultWarningModal).modal('show');

        // Confirm
        $(this.defaultWarningModal).one('shown.bs.modal', function (e) {
            confirmButton.one("click", function () {
                $(that.defaultWarningModal).modal('hide');

                if (type === 'remove') {
                    that.removeProject(projId);
                } else if (type === 'create') {
                    that.createEmptyProject().then(function (data) {
                        window.location.href = window.location.href.replace(/\?.+$/, "") + "?id=" + data.id;
                    });
                } else if (type === 'copy') {
                    that.copyProject(projId).then(function (data) {
                        window.location.href = window.location.href.replace(/\?.+$/, "") + "?id=" + data.id;
                    });
                }
            });
        });

        // Destroy
        $(this.defaultWarningModal).one('hide.bs.modal', function (e) {
            if (type === 'complete') {
                $('.main').hide();
                $('.bl-project-success').show();
            }
            confirmButton.off("click");
        });
    }

    successNewProject(e) {
        e.preventDefault();
        this.createEmptyProject().then(function (data) {
            window.location.href = window.location.href.replace(/\?.+$/, "") + "?id=" + data.id;
        });
    }

}

$(document).ready(function () {
    if ($('#prijava-form').length > 0) new FormSubmits();
    if ($('#prijava-login').length > 0) FormSubmits.ajaxLoad();

    if ($('.bl-project-slider').length) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $('.bl-project-slider').offset().top
        }, 1000);
    }

    $('#success-dashboard').on('click', function(e) {
        e.preventDefault();
        window.location.reload();
    });
});
